import type { ReactNode } from "react";

import { PopupAnchorContext } from "./PopupAnchorContext";

/** Stops nested components of the trigger's type from claiming its anchor. */
export const PopupAnchorBoundary = ({ children }: { children?: ReactNode }) => (
  <PopupAnchorContext value={null}>{children}</PopupAnchorContext>
);
